<template>
  <v-container fluid>
    <v-layout row fill-height>
      <v-flex xs12>
        <v-list
          id="allTrackings"
          three-line
          style="max-height: calc(100vh - 80px)"
          class="overflow-y-auto"
        >
          <v-flex
            v-scroll:#allTrackings="onScroll"
            align="center"
            justify="center"
          >
            <template v-for="(monthedTrackings, monthIndex) in allTrackings">
              <v-subheader class=".title" :key="'subheader-month-'+monthIndex">
                {{mapYearMonth(monthedTrackings.month)}}
              </v-subheader>
              <template v-for="(groupedTrackings, groupIndex) in monthedTrackings.userGroupedServiceTrackings">
                <v-subheader class=".subheading" :key="'subheader-' + monthIndex + '-' +    groupIndex">
                  {{getSubheader(groupedTrackings.usersServiceTracking)}}
                </v-subheader>
                <template v-for="(tracking,index) in groupedTrackings.usersServiceTracking">
                  <v-list-item
                    :key="monthIndex+'_'+groupIndex+'_'+index"
                  >
                    <v-list-item-avatar>
                      <v-list-item-action>
                        <v-checkbox
                          color="primary"
                          v-model="tracking.approved"
                          @click="openApproveServiceTracking(tracking)">
                        </v-checkbox>
                      </v-list-item-action>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{tracking.customer.firstName}} {{tracking.customer.lastName}}
                      </v-list-item-title>
                      <v-list-item-subtitle>{{tracking.customer.street}}, {{tracking.customer.zipCode}}
                        {{tracking.customer.lastName}}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>{{getDate(tracking.startTime)}}:
                        {{getTime(tracking.startTime)}}-{{getTime(tracking.finishTime)}}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>{{tracking.service.name}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn text
                             icon
                             @click="openEditServiceTracking(tracking)"
                             color="primary">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-btn text
                             icon
                             @click="openDeleteServiceTracking(tracking)"
                             color="primary">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index +1 < groupedTrackings.usersServiceTracking.length"
                    :inset="true"
                    :key="'divider-'+ groupIndex +'-'+ index"
                  ></v-divider>
                </template>
              </template>
            </template>
          </v-flex>
        </v-list>
        <data-loader></data-loader>
        <new-tracking-dialog :show="showNewServiceTrackingDialog"
                             @close="closeNewServiceTracking"></new-tracking-dialog>
        <edit-service-tracking-dialog :service-tracking="selectedRecord" :show="showEditServiceTrackingDialog"
                                      @close="closeEditServiceTracking"></edit-service-tracking-dialog>
        <delete-service-tracking-confirm-dialog :service-tracking="selectedRecord"
                                                :show="showDeleteServiceTrackingConfirmDialog"
                                                @close="closeDeleteServiceTracking"></delete-service-tracking-confirm-dialog>
        <approve-service-tracking-dialog :service-tracking="selectedRecord" :show="showApproveServiceTrackingDialog"
                                         @close="closeApproveServiceTracking"></approve-service-tracking-dialog>
      </v-flex>
      <!--<div class="text-xs-center button-center">-->
        <!--<v-btn-->
          <!--fab-->
          <!--color="pink"-->
          <!--dark-->
          <!--@click="openNewServiceTracking"-->
        <!--&gt;-->
          <!--<v-icon>add</v-icon>-->
        <!--</v-btn>-->
      <!--</div>-->
    </v-layout>
  </v-container>
</template>

<script>
  import newServiceTrackingDialog from './NewServiceTrackingDialog'
  import EditServiceTrackingDialog from './EditServiceTrackingDialog'
  import DeleteServiceTrackingConfirmDialog from './DeleteServiceTrackingConfirmDialog'
  import ApproveServiceTrackingDialog from './ApproveServiceTrackingDialog'

  export default {
    name: 'ServiceTracking',
    components: {
      'new-tracking-dialog': newServiceTrackingDialog,
      'edit-service-tracking-dialog': EditServiceTrackingDialog,
      'delete-service-tracking-confirm-dialog': DeleteServiceTrackingConfirmDialog,
      'approve-service-tracking-dialog': ApproveServiceTrackingDialog
    },
    data () {
      return {
        page: 0,
        size: 30,
        bottom: false,
        showNewServiceTrackingDialog: false,
        showEditServiceTrackingDialog: false,
        showDeleteServiceTrackingConfirmDialog: false,
        showApproveServiceTrackingDialog: false,
        selectedRecord: {
          id: null,
          customer: null,
          service: null,
          date: null,
          startTime: null,
          finishTime: null,
          approved: false
        }
      }
    },
    watch: {
      bottom (bottom) {
        if (bottom) {
          this.page++
          this.loadAllServicesTrackings()
        }
      }
    },
    computed: {
      allTrackings: function () {
        return this.$store.getters.allServiceTrackings
      }
    },
    created () {
      this.resetTrackings()
    },
    methods: {
      loadAllServicesTrackings: function () {
        this.$store.dispatch('loadAllServicesTrackings',
          {
            page: this.page,
            size: this.size
          })
      },
      onScroll: function (e) {
        const scrollY = e.target.scrollTop
        const visible = e.target.clientHeight
        const pageHeight = e.target.scrollHeight - 64.0 // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
        const bottomOfPage = visible + scrollY >= pageHeight
        this.bottom = bottomOfPage || pageHeight < visible
      },
      getDate: function (millis) {
        const date = new Date(millis)
        let dd = date.getDate()
        let mm = date.getMonth() + 1
        const yyyy = date.getFullYear()

        if (dd < 10) {
          dd = `0${dd}`
        }

        if (mm < 10) {
          mm = `0${mm}`
        }

        return `${dd}.${mm}.${yyyy}`
      },
      getTime: function (millis) {
        const date = new Date(millis)
        let mn = date.getMinutes()
        let hr = date.getHours()

        if (mn < 10) {
          mn = `0${mn}`
        }

        if (hr < 10) {
          hr = `0${hr}`
        }

        return `${hr}:${mn}`
      },
      getDay: function (millis) {
        const ms = new Date(millis)
        const msPerDay = 86400000
        let beginning = ms - (ms % msPerDay)
        beginning += ((new Date()).getTimezoneOffset() * 60 * 1000)
        return beginning
      },
      getSubheader: function (group) {
        if (group[0]) {
          return group[0].user.lastName + ', ' + group[0].user.firstName + ':'
        }
        return ''
      },
      mapYearMonth: function (yearMonth) {
        const splitted = yearMonth.split('-')
        const date = new Date(splitted[0], splitted[1] - 1)
        return date.toLocaleString('de-de', { month: 'long' }) + ' ' + splitted[0]
      },
      openNewServiceTracking: function () {
        this.showNewServiceTrackingDialog = true
      },
      closeNewServiceTracking: function () {
        this.showNewServiceTrackingDialog = false
        this.resetTrackings()
      },
      openEditServiceTracking: function (record) {
        this.selectedRecord = {
          id: record.id,
          user: record.user,
          customer: record.customer,
          service: record.service,
          date: this.getDay(record.startTime),
          startTime: this.getTime(record.startTime),
          finishTime: this.getTime(record.finishTime)
        }
        this.showEditServiceTrackingDialog = true
      },
      closeEditServiceTracking: function () {
        this.showEditServiceTrackingDialog = false
      },
      openDeleteServiceTracking: function (record) {
        this.selectedRecord = {id: record.id}
        this.showDeleteServiceTrackingConfirmDialog = true
      },
      closeDeleteServiceTracking: function () {
        this.showDeleteServiceTrackingConfirmDialog = false
        this.resetTrackings()
      },
      openApproveServiceTracking: function (record) {
        record.approved = true
        this.selectedRecord = record
        this.showApproveServiceTrackingDialog = true
      },
      closeApproveServiceTracking: function () {
        this.showApproveServiceTrackingDialog = false
        if (this.getNumberOfDisplayedTrackings() < 15) {
          this.page++
          this.loadAllServicesTrackings()
        }
      },
      getNumberOfDisplayedTrackings: function () {
        var trackingsNumber = 0
        this.allTrackings.forEach(monthGroup => {
          monthGroup.userGroupedServiceTrackings.forEach(trackingsOfUserPerMonth => {
            trackingsNumber += trackingsOfUserPerMonth.usersServiceTracking.length
          })
        })
        return trackingsNumber
      },
      resetTrackings: function () {
        this.page = 0
        this.size = 30
        this.$store.dispatch('resetServiceTrackings')
        this.loadAllServicesTrackings()
      }
    }
  }
</script>

<style scoped>

  div.button-center {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/ServiceTracking/AllServiceTracking.vue